<ngx-loading [show]="loading" [config]="{backdropBorderRadius: '14px'}"></ngx-loading>
<nb-layout>
  <nb-layout-header>
    <ngx-header></ngx-header>
  </nb-layout-header>
  <nb-layout-column>
    <section class="content-sectiton">
      <div class="container">
        <div *ngIf=linkExpired class="alert custom-alert-danger" role="alert">
          <p>
            Email verification link has expired!!
          </p>
        </div>
      </div><!-- .content-inner -->
    </section>
  </nb-layout-column>
</nb-layout>
